import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, DateField, enumField, listField } from './util';
import { Game } from './game';
import { Tournament } from './tournament';
import { League } from './league';
import { LeagueNews } from './league-news';

export enum TournamentEventTypes {
  game_closed = 1,
  media_added,
  news
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    game: 'game',
    news: 'news',
    league: 'league',
    tournaments: 'tournaments',
    event: 'event',
    datetime: 'datetime'
  },
  relation: {
    game: Game,
    news: LeagueNews,
    league: League,
    tournaments: listField(Tournament),
    datetime: DateField,
    event: enumField(TournamentEventTypes)
  }
})
export class TournamentEvent extends BaseModel {
  id: number;
  game: Game;
  news: LeagueNews;
  tournaments: Tournament[];
  event: TournamentEventTypes;
  datetime: Date;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
